import React from 'react';
import { Table } from 'semantic-ui-react';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import TableHeader from '@/components/table/TableHeader';
import SearchesTableColumns from '../containers/SearchesTableColumns';

const SearchesTableHeader = ({
  category,
  children,
  columns,
  hideColumns,
  loaderButton,
  readErrors,
  readStatus,
  searches,
}) => (
  <Table.Header fullWidth>
    <TableHeader
      isLoading={readStatus === states.PENDING}
      error={firstErrorMessage(readErrors)}
      numberOfColumns={columns.length}
      loaderButton={loaderButton}
    >
      {children}
    </TableHeader>
    {!hideColumns && <SearchesTableColumns category={category} items={searches} columns={columns} />}
  </Table.Header>
);

export default SearchesTableHeader;
